import { useEffect, useState } from 'react';

import { fetchServices } from '../services/api';
import { ServicesData } from '../services/types';

export interface UseServicesReturn {
  data: ServicesData | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/**
 * Hook to fetch and manage services data
 */
export function useServices(): UseServicesReturn {
  const [data, setData] = useState<ServicesData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetchServices();
      setData(response.data);
    } catch (err) {
      console.error('Error in useServices:', err);
      setError(err instanceof Error ? err.message : 'Unknown error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const refetch = async () => {
    await fetchData();
  };

  return {
    data,
    loading,
    error,
    refetch,
  };
}
